export default __webpack_public_path__ + "static/media/SustainableSourcing.12643282.mp4";